import { InjectConfig, ModelsExperienceConfigKey } from '@ddt-web/config-layer';
import * as find from 'lodash/find';
import * as flatten from 'lodash/flatten';
import * as groupBy from 'lodash/groupBy';
import * as isEmpty from 'lodash/isEmpty';
import * as values from 'lodash/values';

import { ApplicationConstants } from '../config';
import { ModelRowData, ModelsExperienceFilters } from '../models';


// TODO swchopra: convert to helper service because of content service
export class ModelsBrowseFilterTransformUtil {

	private static readonly standardFilters = ['riskProfile', 'preferences', 'tradeFrequency'];
	private static readonly objectiveFilters = ['growth', 'income', 'capital_preservation'];
	@InjectConfig(ModelsExperienceConfigKey.DROP_DOWN_FILTERS) private static readonly dropDownFilters: Array<ModelsExperienceFilters> = [];
	@InjectConfig(ModelsExperienceConfigKey.DROPDOWN_FILTER_MAPPING) private static readonly dropdownFilterMapping: { [key: string]: string } = {};
	/**
	 * Transforms filter query Params to list of ModelsBrowseFilters
	 * e.g. family.vehicle:mf_only,etf_only => 
	 *  [{applicability: 'family', filterId:'vehicle', options:['mf_only', 'etf_only']}]
	 *
	 * @static
	 * @param {string} filterQueryParam
	 * @return {*}  {Array<ModelsBrowseSelectedFilter>}
	 * @memberof ModelsBrowseFilterTransformUtil
	 */
	public static transformUrlToFilterList(filterQueryParam: string): Array<ModelsExperienceFilters> {
		const filterList: Array<ModelsExperienceFilters> = [];
		if (filterQueryParam) {
			const urlFilterList = filterQueryParam.split('$');
			if (!isEmpty(urlFilterList)) {
				urlFilterList.forEach(filterElement => {

					const [applicability, otherParam] = filterElement.split('.');
					if (!!applicability && !!otherParam) {
						const [filterId, optionList] = otherParam.split(':');
						const options = optionList?.split(',');
						const filterObj = {} as ModelsExperienceFilters;
						filterObj.applicability = applicability;
						filterObj.meFilterId = filterId;
						if (!isEmpty(options)) {
							filterObj.options = options;
							filterObj.meFilterKey = filterId;
							filterObj.meFilterGroup = this.getFilterGroup(filterId);
						} else {
							filterObj.options = [];
							filterObj.meFilterKey = this.getFilterKey(filterId);
							filterObj.meFilterGroup = 'highlighted';
						}
						filterList.push(filterObj);
					}
				});
			}
		}
		return filterList;
	}

	public static getFilterQueryParam(selectedFilters: Array<ModelsExperienceFilters>): Array<string> {

		const filterQueryParams = [];
		const groupedData = groupBy(selectedFilters, 'meFilterId');
		Object.keys(groupedData).forEach(filterId => {
			const selectedFilter = groupedData?.[filterId] ?? [];
			let selectedOptions = find(selectedFilter, 'options')?.options ?? '';
			if (selectedFilter.length > 1) {
				selectedOptions = selectedFilter.map(item => item.options);
				selectedOptions = flatten(selectedOptions);
			}
			const applicability = find(selectedFilter, 'applicability')?.applicability ?? '';
			const group = find(selectedFilter, 'meFilterGroup')?.meFilterGroup ?? '';
			if (group === ApplicationConstants.HIGHLIGHTED) {
				filterQueryParams.push(applicability + '.' + filterId);
			}
			else {
				filterQueryParams.push(applicability + '.' + filterId + ':' + selectedOptions?.join(','));
			}
		});

		return filterQueryParams;
	}

	public static getFilterList(filterKeys: string[], filterGroup?: string): Array<ModelsExperienceFilters> {
		const filterList: Array<ModelsExperienceFilters> = [];
		filterKeys.forEach(filterKey => {
			let filterKeyList: Array<ModelsExperienceFilters> = [];
			if (filterGroup !== ApplicationConstants.HIGHLIGHTED) {
				const dropdownFilterKey = this.dropdownFilterMapping?.[filterKey] || filterKey;
				filterKeyList = this.dropDownFilters.filter(item => item.options.includes(dropdownFilterKey) && item.meFilterGroup !== ApplicationConstants.HIGHLIGHTED);
				if (filterKeyList?.length) {
					const newFilterObj: ModelsExperienceFilters = {
						meFilterId: filterKeyList[0].meFilterId,
						meFilterKey: filterKeyList[0].meFilterKey,
						meFilterName: filterKeyList[0].meFilterName,
						meFilterGroup: filterKeyList[0].meFilterGroup,
						applicability: filterKeyList[0].applicability,
						options: [dropdownFilterKey]
					};
					filterList.push(newFilterObj);
				}

			} else {
				filterKeyList = this.dropDownFilters.filter(item => item.meFilterId === filterKey && item.meFilterGroup === filterGroup);
				filterList.push(filterKeyList[0]);
			}
		});

		return filterList;
	}

	/**
	 * This method transforms queryParam from URL to flat model data obj
	 *
	 * @static
	 * @param {string} modelsQueryParam
	 * @return {*}  {Array<{ [key: string]: string }>}
	 * @memberof ModelsBrowseFilterTransformUtil
	 */
	public static transformUrlToSelectedModels(modelsQueryParam: string): Array<{ [key: string]: string }> {
		let selectedModelsList = [];
		const modelsList = modelsQueryParam?.split('$');
		if (!isEmpty(modelsList)) {
			selectedModelsList = modelsList.map((model) => {
				const [familyId, modelIds] = model.split(':');
				const modelIdsArr = modelIds.split(',');
				const modelsData = modelIdsArr.map(modelId => {
					return { modelId, familyId };
				});
				return modelsData;
			});
		}
		return flatten(selectedModelsList);
	}

	/**
	 * This method transforms list of selected models object to list of queryParam string
	 *
	 * @static
	 * @param {Array<ModelRowData>} selectedModels
	 * @return {*}  {Array<string>}
	 * @memberof ModelsBrowseFilterTransformUtil
	 */
	public static getSelectedModelsQueryParam(selectedModels: Array<ModelRowData>): Array<string> {
		const uniqueFamilies = groupBy(selectedModels, 'familyId');
		const selectedModelsParams = values(uniqueFamilies).map(family => {
			const modelIds = family.map(data => data?.modelId);
			const mParam = family[0]?.familyId + ':' + modelIds.toString();
			return mParam;
		});
		return selectedModelsParams;
	}

	/**   
	 * 
	 * @param filterId 
	 * @returns 
	 */
	private static getFilterGroup(filterId: string): string {
		if (this.standardFilters.some((id) => id === filterId)) {
			return 'Standard';
		} else {
			return 'More Filters';
		}
	}

	private static getFilterKey(filterId: string): string {
		if (this.objectiveFilters.some((id) => id === filterId)) {
			return 'objective';
		}
		else {
			return 'preferences';
		}
	}
}
